import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { DataService_StudentLocker } from "../shared/data.service";
import { LockerPersonInsertRequest } from "../shared/LockerPersonInsertRequest";
import * as moment from "moment";

@Component({
	selector: "app-student-add-locker",
	templateUrl: "./student-add-locker.component.html",
	styleUrls: ["./student-add-locker.component.css"],
})
export class StudentAddLockerComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private StudentLockerService: DataService_StudentLocker
	) {}

	ngOnInit(): void {
		this.SelectedPerson = this.dialogConfig.data.SelectedPerson;
		this.user = this.dialogConfig.data.user;

		this.loadLocker();

		this.StudentName = this.SelectedPerson.PersonName;
	}

	////////////////////////////////////////
	// Data
	////////////////////////////////////////
	SelectedPerson: any;
	user: any;

	StudentName: any;

	//Form
	LockerStatusID: any = 1;
	lstLockerStatus: any = [
		{
			ID: 1,
			Desc: "All",
		},
		{
			ID: 2,
			Desc: "Assigned",
		},
		{
			ID: 3,
			Desc: "Unassigned",
		},
	];

	SelectedLocker: any;
	lstLockerAll: any = [];
	lstLocker: any = [];

	AssignedDate: Date = new Date();

	LockerComment: any = "";
	AssignmentComment: any = "";

	errorMessage: any = "";

	////////////////////////////////////////

	////////////////////////////////////////
	// Load Data
	////////////////////////////////////////
	loadLocker() {
		var result = this.StudentLockerService.LockerSelectList(this.SelectedPerson.SchoolID);
		result.subscribe(
			(response) => {
				this.lstLockerAll = response;

				this.SelectedLocker = this.lstLockerAll[0];

				this.UpdateLockerList();
			},
			(error) => {}
		);
	}

	UpdateLockerList() {
		if (this.LockerStatusID == 1) {
			this.lstLocker = this.lstLockerAll;
		} else if (this.LockerStatusID == 2) {
			this.lstLocker = this.lstLockerAll.filter((locker) => locker.PersonID > 0);
		} else if (this.LockerStatusID == 3) {
			this.lstLocker = this.lstLockerAll.filter((locker) => locker.PersonID == 0);
		}

		this.SelectedLocker = this.lstLocker[0];
		this.UpdateComments();
	}

	UpdateComments() {
		this.LockerComment = this.SelectedLocker.Comment;
	}

	////////////////////////////////////////

	////////////////////////////////////////
	// Buttons
	////////////////////////////////////////
	onAssign() {
		this.errorMessage = "";

		if (this.SelectedLocker == undefined) {
			this.errorMessage = "Select a locker";
			return;
		}

		if (this.LockerComment == "") {
			this.errorMessage = "Enter locker combination";
			return;
		}

		//Check Selected Person already assigned a locker
		var result = this.StudentLockerService.StudentHasLocker(this.SelectedPerson.PersonID);
		result.subscribe(
			(response) => {
				var RawData: any = response;

				if (RawData.length > 0) {
					var LockerNum = RawData[0].LockerNum;

					var MultiMSG = "Student is already assigned locker: " + LockerNum + ". Are you sure you want to assign them additional lockers?";

					this.confirmationService.confirm({
						key: "addMulti",
						acceptLabel: "Yes",
						rejectLabel: "No",
						rejectVisible: true,
						message: MultiMSG,
						header: "Confirm Assign Multiple Lockers",
						icon: "fa",
						accept: () => {
							this.CheckActive();
						},
					});
				} else {
					this.CheckActive();
				}
			},
			(error) => {}
		);
	}

	CheckActive() {
		//Check selected person is inactive
		if (this.SelectedPerson.Active == 0) {
			this.confirmationService.confirm({
				key: "addActive",
				acceptLabel: "Yes",
				rejectLabel: "No",
				rejectVisible: true,
				message: "Selected Student is Inactive. Are you sure you want to continue?",
				header: "Confirm Student",
				icon: "fa",
				accept: () => {
					this.CheckAssigned();
				},
			});
		}

		//Check locker is already assigned
		else {
			this.CheckAssigned();
		}
	}

	CheckAssigned() {
		if (this.SelectedLocker.PersonID == this.SelectedPerson.PersonID) {
			this.confirmationService.confirm({
				key: "addError",
				acceptLabel: "Ok",
				rejectVisible: false,
				message: "Locker is already assigned to this student.",
				header: "ERROR",
				icon: "fa",
				accept: () => {},
			});
		} else if (this.SelectedLocker.PersonID > 0) {
			var AssignedErrorMsg = "Locker is already assigned to: " + this.SelectedLocker.AssignedTo + ".";

			this.confirmationService.confirm({
				key: "addError",
				acceptLabel: "Ok",
				rejectVisible: false,
				message: AssignedErrorMsg,
				header: "ERROR",
				icon: "fa",
				accept: () => {},
			});
		} else {
			this.FinishAssign();
		}
	}

	FinishAssign() {
		let parms: LockerPersonInsertRequest = {
			LockerID: this.SelectedLocker.LockerID,
			PersonID: this.SelectedPerson.PersonID,
			MoveInDate: moment(this.AssignedDate).format("MM/DD/YYYY"),
			AssignmentComment: this.AssignmentComment,
			LockerComment: this.LockerComment,
		};

		var result = this.StudentLockerService.LockerPersonInsert(parms);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "add",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Locker was assigned successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "add",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not assign the Locker",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onClose() {
		this.ref.close(0);
	}

	////////////////////////////////////////

	////////////////////////////////////////
	// Events
	////////////////////////////////////////
	onLockerStatusChange(val) {
		this.LockerStatusID = val;

		//Filter lockers
		this.UpdateLockerList();
	}

	onLockerChange(val) {
		this.SelectedLocker = val;

		//Update Comments (Should have combination)
		this.UpdateComments();
	}

	////////////////////////////////////////
}
